import { Pipe, PipeTransform } from '@angular/core';
import { SteelUnit } from '@lobos/library';
import { TranslocoService } from '@ngneat/transloco';

/**
 * Resolves the display text of an input unit (Eingabeeinheit, BO3_ARTICLESALESUNITS.QUANTITYUNITINPUT).
 *
 * The unit key is used as translation key below `shared.units`. If no translation is maintained for the
 * key, the unit data coming from the ERP is used as fallback.
 */
@Pipe({
  name: 'articleUnitName',
})
export class ArticleUnitNamePipe implements PipeTransform {
  private static readonly TRANSLATION_PREFIX = 'shared.units';

  constructor(private transloco: TranslocoService) {}

  public transform(unit: SteelUnit | string | undefined | null): string {
    if (!unit) {
      return '';
    }

    const key: string = (typeof unit === 'string' ? unit : unit.sQuantityUnitInput)?.trim();
    if (!key) {
      return '';
    }

    const translationKey = `${ArticleUnitNamePipe.TRANSLATION_PREFIX}.${key}`;
    const translation: string = this.transloco.translate(translationKey);
    if (translation && translation !== translationKey) {
      return translation;
    }

    if (typeof unit === 'string') {
      return unit;
    }

    return unit.sP48QuantityUnitWebshop || unit.sQuantityUnitInputName || key;
  }
}
